import React, { useState } from 'react';

/**
 * Modal de confirmación para acciones destructivas (borrado masivo, etc.).
 * Exige que el usuario escriba `confirmWord` (default "BORRAR") para habilitar
 * el botón de confirmación.
 */
const ConfirmDestructive = ({
  title = 'Confirmar acción destructiva',
  message,
  count,
  confirmWord = 'BORRAR',
  confirmLabel = 'Eliminar',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const [text, setText] = useState('');
  const matches = text.trim().toUpperCase() === confirmWord.toUpperCase();

  return (
    <div className="modal-overlay" style={{ zIndex: 10001 }}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ color: '#ef4444' }}>{title}</h2>
          <button className="modal-close" onClick={onCancel}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{
            background: 'rgba(239,68,68,0.08)',
            border: '1px solid rgba(239,68,68,0.25)',
            borderRadius: 8, padding: '12px 14px', marginBottom: 14,
            display: 'flex', gap: 10, alignItems: 'flex-start',
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" style={{ flexShrink: 0, marginTop: 2 }}>
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <div style={{ fontSize: 13, color: '#fca5a5', lineHeight: 1.5 }}>
              {message}
              {typeof count === 'number' && (
                <div style={{ marginTop: 6, fontWeight: 700, color: '#ef4444' }}>
                  Se eliminarán <strong>{count}</strong> registro{count !== 1 ? 's' : ''}.
                </div>
              )}
              <div style={{ marginTop: 4, fontSize: 12, color: '#94a3b8' }}>
                Los registros con documentos relacionados (OC/PE/GR) se saltarán automáticamente.
              </div>
            </div>
          </div>
          <label style={{ fontSize: 12, color: '#94a3b8', display: 'block', marginBottom: 6 }}>
            Para confirmar, escribe <strong style={{ color: '#ef4444', fontFamily: 'monospace' }}>{confirmWord}</strong>:
          </label>
          <input
            autoFocus
            value={text}
            onChange={e => setText(e.target.value)}
            disabled={loading}
            placeholder={confirmWord}
            style={{
              width: '100%', padding: '8px 12px', borderRadius: 8,
              border: `1px solid ${matches ? 'rgba(239,68,68,0.5)' : 'rgba(255,255,255,0.1)'}`,
              background: 'rgba(255,255,255,0.03)', color: '#e2e8f0',
              fontSize: 14, fontFamily: 'monospace', letterSpacing: '1px',
              outline: 'none',
            }}
          />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>Cancelar</button>
          <button
            type="button"
            className="btn"
            disabled={!matches || loading}
            onClick={onConfirm}
            style={{
              background: matches && !loading ? '#ef4444' : 'rgba(239,68,68,0.2)',
              color: matches && !loading ? '#fff' : '#94a3b8',
              border: '1px solid rgba(239,68,68,0.4)',
              cursor: matches && !loading ? 'pointer' : 'not-allowed',
            }}>
            {loading ? 'Eliminando...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDestructive;
